export const ROUTE_CHECKOUT = '/checkout'

export default {
  checkout: ROUTE_CHECKOUT,
}
